import { render, staticRenderFns } from "./ClientManage.vue?vue&type=template&id=0c0e37b8&scoped=true&"
import script from "./ClientManage.vue?vue&type=script&lang=js&"
export * from "./ClientManage.vue?vue&type=script&lang=js&"
import style0 from "./ClientManage.vue?vue&type=style&index=0&id=0c0e37b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e37b8",
  null
  
)

export default component.exports